import React, { useEffect, useState } from 'react';
import { pathHome } from '../../path';
import styles from './clients-page.module.css';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AddClients from '../../components/AddClients/AddClients';
import { deleteClientBd, getClientsDb } from '../../firebase';
import { addClientsRedux, deleteClientRedux } from '../../store/slices/clientsSlice';
import LoaderPage from '../../components/LoaderPage/LoaderPage';

export default function ClientsPage() {
  const dispatch = useDispatch();
  const [popupAddClients, setPopupAddClients] = useState(false);
  const [loaderPage, setLoaderPage] = useState(false);
  const clients = useSelector((state) => state.clients.clients);
  // Пошук клієнтів
  const [searchСlientsArray, setSearchСlientsArray] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!clients.length) {
      setLoaderPage(true);
      const getClients = async () => {
        const clients = await getClientsDb();
        dispatch(addClientsRedux(clients));
        // console.log('clients ===', clients);
        setLoaderPage(false);
      };
      getClients();
    }
  }, []);

  const deleteClient = async (client_id) => {
    setLoaderPage(true);
    const isDeleteClient = window.confirm('Видалити клієнта?');
    if (isDeleteClient) {
      const ifDeleteClient = await deleteClientBd(client_id);
      if (ifDeleteClient) {
        dispatch(deleteClientRedux(client_id));
        alert('Видалено успішно.');
      } else {
        alert('Не вдолося видалити клієнта.');
      }
    }
    setLoaderPage(false);
  };

  const renderClients = (clients) => {
    return clients.map((item) => {
      return (
        <div key={item.client_id} className={styles.client_wrapper}>
          {item.newClient && <div className={styles.client_new}>Новий клієнт!</div>}
          <div className={styles.top_block}>
            <Link
              to={`/${pathHome}/client-info/${item.client_id}`}
              className={
                item.fromAdvertising
                  ? styles.client_info + ' ' + styles.client_info_fromAdvertising
                  : item.ownСlient
                  ? styles.client_info + ' ' + styles.client_info_ownСlient
                  : item.potentialClient
                  ? styles.client_info + ' ' + styles.client_info_potentialClient
                  : styles.client_info
              }>
              {item.fullName}
              <div className={styles.client_tel}>{item.tel}</div>
            </Link>
            <div
              className={styles.delete_client_wrapper}
              onClick={() => deleteClient(item.client_id)}>
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3 3H18V18C18 19.1046 17.1046 20 16 20H5C3.89543 20 3 19.1046 3 18V3Z"
                  fill="#FF5C5E"></path>
                <rect width="21" height="2" rx="1" fill="#FF5C5E"></rect>
              </svg>
            </div>
          </div>
        </div>
      );
    });
  };

  const getClientCountFromAdvertising = (clients) => {
    let count = 0;
    clients.forEach((client) => {
      if (client.fromAdvertising) {
        count++;
      }
    });
    return count;
  };

  // Підраховує клієнти які вже були на супроводі
  const getClientCountOwnСlient = (clients) => {
    let count = 0;
    clients.forEach((client) => {
      if (client.ownСlient) {
        count++;
      }
    });
    return count;
  };

  // Пошук
  const searchСlients = (clients, inputValue) => {
    setSearch(inputValue);

    const result = [];

    clients.forEach((item) => {
      if (item.fullName.toLowerCase().search(inputValue.toLowerCase()) != -1) {
        result.push(item);
      }
    });
    setSearchСlientsArray(result);
  };

  return (
    <>
      <div className={styles.header_wrapper}>
        <Link className={styles.header_link} to={`/${pathHome}/home`}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9L11.25 0.339745V17.6603L0 9Z" fill="white" />
          </svg>
          Головна
        </Link>
        <div>
          Клієнти{' '}
          {clients.length
            ? `${search ? searchСlientsArray.length : clients.length} / ${getClientCountOwnСlient(
                search ? searchСlientsArray : clients,
              )} / ${getClientCountFromAdvertising(search ? searchСlientsArray : clients)}`
            : '-'}{' '}
        </div>
        <svg
          onClick={() => setPopupAddClients(true)}
          className={styles.interaction_item}
          width="35"
          height="36"
          viewBox="0 0 35 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect y="2.60376" width="34.7273" height="33.0189" rx="10" fill="#A22CA7" />
          <path
            d="M16.2182 26.4091V11.4091H18.7636V26.4091H16.2182ZM9.99089 20.1818V17.6364H24.9909V20.1818H9.99089Z"
            fill="white"
          />
        </svg>
      </div>
      <div className={styles.content_wrapper}>
        <input
          type="text"
          className={styles.input_search}
          placeholder="Пошук"
          value={search}
          onChange={(e) => searchСlients(clients, e.target.value.trimStart())}
        />
        {clients.length ? (
          renderClients(search ? searchСlientsArray : clients)
        ) : loaderPage ? (
          <div>Загрузка...</div>
        ) : (
          <div>Пусто:)</div>
        )}
      </div>
      {popupAddClients && <AddClients setPopup={setPopupAddClients} />}
      {loaderPage && <LoaderPage />}
    </>
  );
}
